// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__EQed5","header":"PatientBlock_header__1nqYe","label":"PatientBlock_label__1Abn5","option":"PatientBlock_option__3FzmZ"};